import React from "react";
import default_image from "../../../../../../assets/images/default_product.png";

import styles from "./MainApp.organisms.Product.Table.TableItemMobile.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
export class ProductTableItemMobile extends React.Component {
  constructor(props){
    super(props);
    this.state={
      imgError: false
    }
  }
  render() {
    const {product, handleClick} = this.props
    return (
      <div className={styles["table-item-mobile-container"]} data-automation-id="product-item" data-product-id={product.id} onClick={handleClick}>
        <div className={styles["table-item-mobile-col-1"]}>
          <div className={styles["table-item-mobile-img"]}>
          <img
              alt="product"
              src={(this.state.imgError || !product.image) ? default_image : product.image}
              onError={() => { this.setState({imgError: true}) }}
            />
          </div>
        </div>
        <div className={styles["table-item-mobile-col-2"]}>
          <div className={styles["table-item-mobile-header"]}>
            <div className={styles["table-item-mobile-name"]}> {product.name} </div>
            <div className={styles["table-item-mobile-header-separator"]}></div>
            <div className={styles["table-item-mobile-brand"]}> {product.brand ? product.brand?.name : '-'} </div>
          </div>
          <div className={styles["table-item-mobile-code"]}>{capitalize(i18n.t("code"))}: {product.sku}</div>
        </div>
        <div className={styles["table-item-mobile-col-3"]}>
          <div className={styles["table-item-mobile-category"]}>
              { (product.categories || []).length > 0 ?
                  product.categories.map((category) => {
                      if (!category) return null;

                      return <div className={styles["table-item-mobile-category-inner"]} key={category.id}>
                          {category.name}
                      </div>
                  })
              :
                  <span>-</span>
              }
          </div>
        </div>
      </div>
    );
  }
}

ProductTableItemMobile.propTypes = {
};

export default ProductTableItemMobile;